import React from 'react';

export default function VidyutAi() {
    const email = localStorage.getItem("email");
    const url = email
        ? `https://qa-gnai-agent.gna.energy/v2?user=${encodeURIComponent(email)}`
        : "https://qa-gnai-agent.gna.energy/v2";

    return (
        <div className="w-full h-[calc(100vh-85px)]">
            <iframe
                src={url}
                title="Vidyut AI Agent"
                className="w-full h-full border-none"
            />
        </div>
    );
}
